/* ============================================================
 * lbf-shipping-core.js  (v1.9)
 * SINGLE SOURCE OF TRUTH for Lady Boss Foodie shipping logic.
 *
 * Mirrors the live cart logic in cart-footer-fix.js v6.25 so that the
 * cart page, the collection floating bar, and any future surface all
 * read the SAME thresholds and the SAME computeShipping() result.
 * Change a number here -> every surface that uses it updates.
 *
 * v1.6 (2026-09-17) adds the MIXED cart lane: a cart holding BOTH paid frozen
 * and paid ready-to-eat (retort) lines keeps one cold-chain delivery but never
 * reaches RM0. See 20260917_LBF_DevBrief_MixedCart_Shipping_Ver1.md.
 *
 * v1.9 (2026-10-22, Carl) adds the SEASONAL box lane: a box holding only
 * cc_solo_ok dishes is priced on the shipping app's Seasonal rates (free for 2+
 * seasonal dishes), alone or as box 1 of a split cart. See
 * cny-ship-display-20261022/20261022_Release_Record.md.
 *
 * Exposes: window.LBF_SHIPPING
 * ============================================================ */
(function () {
  if (window.LBF_SHIPPING) return; // already loaded
  var lbnT = window.lbnT || function (k, f, v) { return v ? String(f).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, x) { return Object.prototype.hasOwnProperty.call(v, x) ? String(v[x]) : m; }) : f; };

  /* Values come from Theme settings via window.LBF_SHIPPING_CONFIG (snippet: lbf-shipping-config.liquid). Fallbacks below = previous hardcoded live values. */
  var LBFCFG = window.LBF_SHIPPING_CONFIG || {};

  /* ---- Thresholds (cents) - keep in sync with cart-footer-fix.js ---- */
  var TKL = LBFCFG.TKL != null ? LBFCFG.TKL : 15000;
  var TKL_RED = LBFCFG.TKL_RED != null ? LBFCFG.TKL_RED : 15000;  // KL/SEL reduced-rate threshold = RM150   // KL/SEL free-shipping threshold (frozen/mix)        = RM150
  var TWM = LBFCFG.TWM != null ? LBFCFG.TWM : 30000;   // Universal West Msia free-shipping threshold (frozen/mix) = RM300
  var TDRY = LBFCFG.TDRY != null ? LBFCFG.TDRY : 15000;  // Dry/Retort West Msia free-shipping threshold       = RM150
  var RD = LBFCFG.RD != null ? LBFCFG.RD : 800;      // Dry/Retort below-threshold rate                    = RM8
  var RF_KL = LBFCFG.RF_KL != null ? LBFCFG.RF_KL : 2000;
  var RF_KL_RED = LBFCFG.RF_KL_RED != null ? LBFCFG.RF_KL_RED : 1000;  // KL/SEL reduced rate (mid tier) = RM10   // KL/SEL frozen/mix below threshold   = RM20
  var RF_WM = LBFCFG.RF_WM != null ? LBFCFG.RF_WM : 3000;  // Other WM frozen/mix below threshold = RM30
  /* MIXED lane (paid frozen + paid retort in one cart). Reduced-fee milestone, never free. */
  var TMIX_KL = LBFCFG.TMIX_KL != null ? LBFCFG.TMIX_KL : 15000; // KL/SEL mixed milestone      = RM150
  var RMIX_KL = LBFCFG.RMIX_KL != null ? LBFCFG.RMIX_KL : 1000;  // KL/SEL mixed floor rate     = RM10
  var TMIX_WM = LBFCFG.TMIX_WM != null ? LBFCFG.TMIX_WM : 30000; // Other WM mixed milestone    = RM300
  var RMIX_WM = LBFCFG.RMIX_WM != null ? LBFCFG.RMIX_WM : 1500;  // Other WM mixed floor rate   = RM15
  var EAST_FROM = LBFCFG.EAST_FROM != null ? LBFCFG.EAST_FROM : 1600; // East Msia weight-based anchor                   = RM16
  /* SEASONAL box (cc_solo_ok only) = shipping app "Seasonal" rates. Fees reuse RF_KL / RF_KL_RED (from TKL_RED) / RF_WM. */
  var TSEA_KL = LBFCFG.TSEA_KL != null ? LBFCFG.TSEA_KL : 20000;    // KL/SEL seasonal box free from     = RM200
  var TSEA_WM = LBFCFG.TSEA_WM != null ? LBFCFG.TSEA_WM : 30000;    // Other WM seasonal box free from   = RM300
  var SEA_FREE_QTY = LBFCFG.SEA_FREE_QTY != null ? LBFCFG.SEA_FREE_QTY : 2; // seasonal dishes that ship free = 2
  var MOQ = 3;       // Minimum frozen QUANTITY for cold-chain checkout

  /* Detection - frozen MOQ is by product TYPE; free-shipping context is by TAG */
  var FROZEN_TYPE = 'frozen';
  var RETORT_TYPE = 'retort';
  var FROZEN_TAGS = ['frozen', 'fbundle', 'cny frozen'];
  /* FIX A (2026-09-18): cc_solo_ok exempts ITS OWN LINE from the frozen minimum.
     It used to lift the minimum for the WHOLE cart, so a Prosperity Pork Knuckle
     riding along with one lonely non-exempt frozen unit disarmed the guard and the
     shopper walked into ShipZip's "Shipping not available" dead end. */
  var SOLO_TAG = 'cc_solo_ok'; // exempts its OWN line from the frozen MOQ
  /* Carl, 2026-09-18: cc_solo_ok IS the split marker, not the CNY tag. Any
     high-ticket seasonal item we launch gets cc_solo_ok because it can check out
     on its own - and the same property is why the warehouse packs it in its own
     foam box. One tag, one meaning: "ships as its own shipment". */
  var LEGACY_REGION_KEY = 'lbf-ship-state';
  var REGULAR_REGION_KEY = 'lbf-ship-region-regular';
  var FROZEN_REGION_KEY = 'lbf-ship-region-frozen';


  function fmt(cents) { return 'RM' + (Number(cents || 0) / 100).toFixed(2); }

  function readRegion(key, allowed) {
    try {
      var value = localStorage.getItem(key);
      return allowed.indexOf(value) !== -1 ? value : null;
    } catch (e) { return null; }
  }
  function writeRegion(key, value, allowed) {
    if (allowed.indexOf(value) === -1) return;
    try { localStorage.setItem(key, value); } catch (e) {}
  }
  function getRegularRegion() { return readRegion(REGULAR_REGION_KEY, ['west-msia', 'east-msia']); }
  function getFrozenRegion() { return readRegion(FROZEN_REGION_KEY, ['kl-sel', 'wm']); }
  function setRegularRegion(value) { writeRegion(REGULAR_REGION_KEY, value, ['west-msia', 'east-msia']); }
  function setFrozenRegion(value) {
    writeRegion(FROZEN_REGION_KEY, value, ['kl-sel', 'wm']);
    if (!getRegularRegion() && (value === 'kl-sel' || value === 'wm')) setRegularRegion('west-msia');
  }
  function migrateLegacyRegion() {
    try {
      var legacy = localStorage.getItem(LEGACY_REGION_KEY);
      if (legacy === 'kl-sel' || legacy === 'wm') {
        if (!getRegularRegion()) setRegularRegion('west-msia');
        if (!getFrozenRegion()) setFrozenRegion(legacy);
      } else if ((legacy === 'west-msia' || legacy === 'east-msia') && !getRegularRegion()) {
        setRegularRegion(legacy);
      }
      if (legacy != null) localStorage.removeItem(LEGACY_REGION_KEY);
    } catch (e) {}
  }
  function activeRegion(frozenCart) {
    if (!frozenCart) return getRegularRegion();
    if (getRegularRegion() === 'east-msia') return 'east-msia';
    return getFrozenRegion();
  }
  migrateLegacyRegion();

  /* cart: { items:[{ qty, linePrice, frozenType, frozenTag, retortType, soloOk }], totalPrice }
     state: already-resolved 'kl-sel' | 'wm' | 'west-msia' | 'east-msia' | null
     opts:  { ignoreMoq: true } to skip the MOQ gate (collection bar). */
  /* ---- Lane classification (brief section 3) --------------------------------
     Only lines with a POSITIVE discounted value are classified, so RM0 gifts,
     packaging and accessories can never turn a pure cart into a mixed one.
     A paid line that is neither frozen nor retort (merch, an accessory, a
     product with no product_type) counts toward paidOtherQty ONLY: it can
     never create the mixed state, and it never removes one either. Frozen
     detection is unchanged (product_type == frozen or an accepted frozen tag,
     both already folded into item.frozenTag by every caller). */
  function classify(cart) {
    var items = (cart && cart.items) || [];
    var paid = items.filter(function (i) { return Number(i.linePrice) > 0; });
    var paidFrozenQty = paid.reduce(function (s, i) { return s + (i.frozenTag ? i.qty : 0); }, 0);
    var paidRetortQty = paid.reduce(function (s, i) { return s + (!i.frozenTag && i.retortType ? i.qty : 0); }, 0);
    var paidOtherQty = paid.reduce(function (s, i) { return s + (!i.frozenTag && !i.retortType ? i.qty : 0); }, 0);
    /* FIX B: a paid split-parcel item sharing the cart with any other paid line
       means checkout will quote 2+ parcels added together. */
    var splitParcel = paid.some(function (i) { return !!i.soloOk; });
    var splitOthers = paid.some(function (i) { return !i.soloOk; });
    /* The two shipments the warehouse will actually pack, so every surface can
       show WHAT is in each box rather than just warning that a split exists. */
    var boxSeasonal = paid.filter(function (i) { return !!i.soloOk; });
    var boxRegular = paid.filter(function (i) { return !i.soloOk; });
    var sum = function (a) { return a.reduce(function (s, i) { return s + i.linePrice; }, 0); };
    var hasFrozen = paidFrozenQty > 0;
    var hasRetort = paidRetortQty > 0;
    /* frozenShip is the COLD-CHAIN lane determinant and is deliberately
       unchanged from v1.5: any frozen line at all, paid or free, puts the whole
       order in a refrigerated truck. Only the MIXED test is paid-lines-only. */
    return {
      paidFrozenQty: paidFrozenQty, paidRetortQty: paidRetortQty, paidOtherQty: paidOtherQty,
      hasFrozen: hasFrozen, hasRetort: hasRetort, mixed: hasFrozen && hasRetort,
      splitParcel: splitParcel, splitWarn: splitParcel && splitOthers,
      boxes: (splitParcel && splitOthers) ? {
        seasonal: { items: boxSeasonal, subtotal: sum(boxSeasonal) },
        regular: { items: boxRegular, subtotal: sum(boxRegular) }
      } : null,
      frozenShip: items.some(function (i) { return i.frozenTag; })
    };
  }

  /* ---- Two-box quote (Carl's policy, confirmed 2026-09-18) -------------------
     A seasonal (cc_solo_ok) item always ships as its own box. Each box is then
     priced on ITS OWN subtotal using the ordinary lanes - the seasonal box on the
     frozen ladder, the other box on whichever lane its contents make it (frozen,
     mixed, or ready-to-eat) - and the customer pays the SUM. Each box therefore
     has its own free-shipping tier, which is the point: it is what makes "buy
     seasonal only, or regular only" the cheaper call.
     Verified against 16 live carts: this matches every Other-WM cart and every
     single-box cart. See DECISION_LOG 2026-09-18 for the 5 KL carts where the
     ShipZip config currently disagrees (it prices a frozen Box 2 off the whole
     cart total and so undercharges). The theme states the policy; the app is
     what needs correcting there. */
  function boxCart(items) {
    return { items: items, totalPrice: items.reduce(function (s, i) { return s + i.linePrice; }, 0) };
  }
  /* Only a settled money state can be added up. moq/pickstate/blocked/eastmsia
     have no single number, so the quote reports "not quotable" rather than guess. */
  function feeOfResult(r) {
    if (!r) return null;
    if (r.kind === 'free') return 0;
    if (r.kind === 'progress' || r.kind === 'mixed-progress' || r.kind === 'mixed-floor') return r.rate;
    return null;
  }
  function baseFeeFor(r) {
    if (!r) return null;
    if (r.kind === 'mixed-progress' || r.kind === 'mixed-floor') return r.baseRate;
    if (r.frozen) return getFrozenRegion() === 'kl-sel' ? RF_KL : RF_WM;
    return RD;
  }
  function splitQuote(cart) {
    var cls = classify(cart);
    if (!cls.splitWarn) return null;
    var s1 = boxCart(cls.boxes.seasonal.items);
    var s2 = boxCart(cls.boxes.regular.items);
    var r1 = compute(s1, activeRegion(s1.items.some(function (i) { return i.frozenTag; })), { ignoreMoq: true, noSplit: true });
    var r2 = compute(s2, activeRegion(s2.items.some(function (i) { return i.frozenTag; })), { ignoreMoq: true, noSplit: true });
    var f1 = feeOfResult(r1), f2 = feeOfResult(r2);
    /* Carl 2026-09-18: whenever a box has reached a better tier, show what it
       WOULD have cost so the saving is visible. baseFee is the rate that box pays
       before any tier kicks in. Only shown when it is actually higher. */
    var box = function (items, sub, r, fee) {
      var base = baseFeeFor(r);
      return { items: items, subtotal: sub, result: r, fee: fee,
        baseFee: base, saved: (base != null && fee != null && base > fee) ? base - fee : 0,
        free: fee === 0,
        threshold: r && r.threshold != null ? r.threshold : null,
        remaining: r && r.remaining != null ? r.remaining : null };
    };
    return {
      seasonal: box(s1.items, s1.totalPrice, r1, f1),
      regular: box(s2.items, s2.totalPrice, r2, f2),
      quotable: f1 != null && f2 != null,
      total: (f1 == null || f2 == null) ? null : f1 + f2
    };
  }

  /* Joy vouchers, read from cart.js alone (Carl, 7 Oct 2026). ORDER = every
     cart-level discount code; cart.js carries its amount. SHIPPING = an
     applicable code that no cart amount accounts for; cart.js never carries its
     value, so the value comes only from the LBNSHIP<ringgit> prefix, else unknown. */
  var SHIP_CODE = /^LBNSHIP(\d+)/i;
  function voucherFromCart(c) {
    var up = function (s) { return String(s || '').toUpperCase(); };
    var orderApps = ((c && c.cart_level_discount_applications) || []).filter(function (a) { return a.type === 'discount_code'; });
    var accounted = orderApps.map(function (a) { return up(a.title); });
    ((c && c.items) || []).forEach(function (li) {
      (li.line_level_discount_allocations || []).forEach(function (d) { accounted.push(up(d.discount_application && d.discount_application.title)); });
    });
    var orderCents = orderApps.reduce(function (s, a) { return s + (Number(a.total_allocated_amount) || 0); }, 0);
    var ship = null;
    ((c && c.discount_codes) || []).forEach(function (d) {
      if (ship || !d.applicable || accounted.indexOf(up(d.code)) !== -1) return;
      var m = SHIP_CODE.exec(d.code);
      ship = { cents: m ? Number(m[1]) * 100 : null, code: d.code, unknown: !m };
    });
    return {
      order: orderCents > 0 ? { cents: orderCents, codes: orderApps.map(function (a) { return a.title; }) } : null,
      ship: ship
    };
  }

  /* A shipping voucher of known value lowers the fee AFTER the tier is chosen, once per
     order (a 2-box split is discounted on its combined fee). voucherNote is the ONE
     delivery line every surface shows while a voucher applies: the whole saving against
     the fee before any tier, or "You enjoy free delivery". Unknown value: silent. */
  function applyShipVoucher(r, voucher) {
    var ship = voucher && voucher.ship;
    var before = (r.kind === 'moq' || r.kind === 'blocked') ? null
      : (r.split ? (r.split.quotable ? r.split.total : null) : feeOfResult(r));
    var cents = (before != null && ship && ship.cents != null) ? ship.cents : null;
    r.feeBefore = before;
    r.feeAfter = cents == null ? before : Math.max(0, before - cents);
    r.feeBase = before == null ? null : (r.split ? r.split.seasonal.baseFee + r.split.regular.baseFee : baseFeeFor(r));
    r.voucherNote = cents == null ? null : (r.feeAfter === 0
      ? { kind: 'free', text: lbnT('ship.you_enjoy_free_delivery', 'You enjoy free delivery') }
      : { kind: 'off', text: lbnT('ship.you_saved_on_delivery', 'You saved {{ amount }} on delivery', { amount: fmt(r.feeBase - r.feeAfter).replace('.00', '') }) });
    /* What reaching the milestone still saves once the voucher is counted: RM20 -> RM5 with
       LBNSHIP15 only drops to RM0, a RM5 saving, not RM10. A split is quoted per box. */
    if (r.kind === 'mixed-progress') {
      var partial = cents != null && !r.split;
      r.tierSaving = partial ? r.feeAfter - Math.max(0, r.floorRate - cents) : r.baseRate - r.floorRate;
      r.tierFree = partial && cents >= r.floorRate;
    }
  }

  /* Public compute(): runs the lane calculation, then stamps the classification
     and the lane onto the result so NO surface has to re-derive policy. */
  function compute(cart, resolvedState, opts) {
    opts = opts || {};
    var cls = classify(cart);
    var r = computeLane(cart, resolvedState, opts, cls);
    if (r.kind === 'empty') return r;
    r.mixed = cls.mixed;
    r.paidFrozenQty = cls.paidFrozenQty;
    r.paidRetortQty = cls.paidRetortQty;
    r.paidOtherQty = cls.paidOtherQty;
    r.lane = cls.mixed ? 'mixed' : (cls.frozenShip ? 'cold-chain' : 'regular');
    r.splitWarn = cls.splitWarn;
    r.boxes = cls.boxes;
    /* noSplit stops the recursion: each box is quoted with it set, and a single
       box never satisfies splitWarn anyway. */
    r.split = (opts && opts.noSplit) ? null : splitQuote(cart);
    applyShipVoucher(r, cart && cart.voucher);
    return r;
  }

  function computeLane(cart, resolvedState, opts, cls) {
    opts = opts || {};
    var items = (cart && cart.items) || [];
    var total = (cart && cart.totalPrice) || 0;

    var countedItems = items.filter(function (i) { return Number(i.linePrice) !== 0; });
    var frozenMOQQty = items.reduce(function (s, i) { return s + (i.frozenType ? i.qty : 0); }, 0);
    var hasFrozenType = frozenMOQQty > 0;
    var frozenShip = items.some(function (i) { return i.frozenTag; });
    /* FIX A: count only the frozen units that are NOT exempt. A solo-ok line no
       longer waives the minimum for a separate frozen line riding along with it. */
    var moqFrozenQty = items.reduce(function (s, i) { return s + (i.frozenType && !i.soloOk ? i.qty : 0); }, 0);
    var totalQty = items.reduce(function (s, i) { return s + i.qty; }, 0);
    var frozenQty = countedItems.reduce(function (s, i) { return s + (i.frozenTag ? i.qty : 0); }, 0);
    var readyQty = countedItems.reduce(function (s, i) { return s + (!i.frozenTag ? i.qty : 0); }, 0);

    if (totalQty === 0) return { kind: 'empty' };

    /* 1) Frozen MOQ gate (quantity) - unless cc_solo_ok present or ignored.
       This is a hard cold-chain minimum: cart value never replaces the
       required three frozen packets. */
    if (!opts.ignoreMoq && moqFrozenQty > 0 && moqFrozenQty < MOQ) {
      return { kind: 'moq', need: MOQ - moqFrozenQty, have: moqFrozenQty, moq: MOQ, frozen: true,
        totalQty: totalQty, frozenQty: frozenQty, readyQty: readyQty, total: total };
    }

    if (frozenShip && resolvedState === 'east-msia') {
      return { kind: 'blocked', reason: 'no-coldchain-east', frozen: true,
        state: 'east-msia', total: total, totalQty: totalQty,
        frozenQty: frozenQty, readyQty: readyQty };
    }

    var state = resolvedState;
    if (frozenShip && state !== 'kl-sel' && state !== 'wm') state = null;
    if (!frozenShip && state !== 'west-msia' && state !== 'east-msia') state = null;

    /* 4) Frozen delivery always needs a cold-chain region. KL/SEL and Other WM
       have different reduced-fee milestones, and neither lane reaches RM0. */
    if (frozenShip && !state) {
      return { kind: 'pickstate', frozen: true, total: total,
        totalQty: totalQty, frozenQty: frozenQty, readyQty: readyQty,
        pills: [['kl-sel', 'KL/SEL'], ['wm', 'Other WM State']] };
    }

    /* 4a) A box of seasonal (cc_solo_ok) dishes only ships on the app's Seasonal
       rates, not the frozen tiers. A split cart reaches here once per box via
       splitQuote, the way checkout quotes each delivery profile on its own. */
    var sPaid = items.filter(function (i) { return Number(i.linePrice) > 0; });
    if (frozenShip && sPaid.length && sPaid.every(function (i) { return i.soloOk; })) {
      var sea = seasonalFee(sPaid.reduce(function (s, i) { return s + i.qty; }, 0), total, state);
      var sOut = { seasonal: true, region: state === 'kl-sel' ? 'KL/SEL' : 'Other WM State', frozen: true,
        threshold: sea.freeAt, floorRate: 0, total: total, totalQty: totalQty, frozenQty: frozenQty,
        readyQty: readyQty, state: state, seasonalQty: sea.qty };
      if (sea.free) return Object.assign(sOut, { kind: 'mixed-floor', rate: 0, baseRate: sea.base, remaining: 0, pct: 100 });
      /* baseRate = today's fee, so every "save X on delivery" line names the fee that 1 more dish removes */
      return Object.assign(sOut, { kind: 'mixed-progress', rate: sea.fee, baseRate: sea.fee,
        remaining: Math.max(0, sea.freeAt - total),
        pct: Math.min(100, Math.max(Math.round(sea.qty / SEA_FREE_QTY * 100), Math.round(total / sea.freeAt * 100))) });
    }

    /* 4b) Any order containing frozen food uses one cold-chain delivery, a
       reduced-fee milestone and never RM0. The internal result names remain
       stable so existing presenters and analytics continue to work. */
    if (frozenShip) {
      var mThreshold = state === 'kl-sel' ? TMIX_KL : TMIX_WM;
      var mBase = state === 'kl-sel' ? RF_KL : RF_WM;
      var mFloor = state === 'kl-sel' ? RMIX_KL : RMIX_WM;
      var mLabel = state === 'kl-sel' ? 'KL/SEL' : 'Other WM State';
      if (total >= mThreshold) {
        return { kind: 'mixed-floor', region: mLabel, frozen: true, threshold: mThreshold,
          rate: mFloor, baseRate: mBase, floorRate: mFloor, remaining: 0, total: total,
          totalQty: totalQty, frozenQty: frozenQty, readyQty: readyQty,
          state: state, pct: 100 };
      }
      return { kind: 'mixed-progress', region: mLabel, frozen: true, threshold: mThreshold,
        rate: mBase, baseRate: mBase, floorRate: mFloor, remaining: mThreshold - total, total: total,
        totalQty: totalQty, frozenQty: frozenQty, readyQty: readyQty,
        state: state, pct: Math.min(100, Math.round((total / mThreshold) * 100)) };
    }

    /* 5) Universal dry-goods auto-free (no area pick needed) */
    var freeAll = !frozenShip && total >= TDRY;
    if (freeAll && state !== 'east-msia') {
      return { kind: 'free', region: 'West Malaysia', frozen: frozenShip,
        saved: frozenShip ? RF_WM : RD, totalQty: totalQty, frozenQty: frozenQty,
        readyQty: readyQty, total: total, state: state };
    }

    /* 6) No regular-delivery area chosen yet */
    if (!state) {
      return { kind: 'pickstate', frozen: frozenShip, total: total,
        totalQty: totalQty, frozenQty: frozenQty, readyQty: readyQty,
        pills: frozenShip ? [['kl-sel', 'KL/SEL'], ['wm', 'Other WM State']]
                          : [['west-msia', 'West Msia'], ['east-msia', 'East Msia']] };
    }

    /* 7) East Msia (dry only) - weight based, never free */
    if (state === 'east-msia') {
      return { kind: 'eastmsia', from: EAST_FROM, frozen: false,
        totalQty: totalQty, frozenQty: frozenQty, readyQty: readyQty, total: total, state: state };
    }

    /* 8) Ready-to-eat value progress toward free delivery */
    var threshold = TDRY;
    var rate = RD;
    var label = 'West Malaysia';
    if (total >= threshold) {
      return { kind: 'free', region: label, frozen: frozenShip, saved: rate,
        totalQty: totalQty, frozenQty: frozenQty, readyQty: readyQty,
        total: total, state: state };
    }
    return { kind: 'progress', region: label, frozen: frozenShip, threshold: threshold,
      rate: rate, remaining: threshold - total, total: total,
      totalQty: totalQty, frozenQty: frozenQty, readyQty: readyQty,
      state: state,
      pct: Math.min(100, Math.round((total / threshold) * 100)) };
  }

  /* The Seasonal rate for one box: qty seasonal dishes worth total (cents) to 'kl-sel' or 'wm'.
     Free for SEA_FREE_QTY+ dishes; KL/SEL RM20, RM10 from RM150, free from RM200; Other WM RM30, free from RM300. */
  function seasonalFee(qty, total, state) {
    var kl = state === 'kl-sel';
    var base = kl ? RF_KL : RF_WM, freeAt = kl ? TSEA_KL : TSEA_WM;
    var free = qty >= SEA_FREE_QTY || total >= freeAt;
    var fee = free ? 0 : (kl && total >= TKL_RED ? RF_KL_RED : base);
    return { qty: qty, fee: fee, base: base, free: free, freeAt: freeAt };
  }
  /* The one nudge for a seasonal box below free: another seasonal dish always frees it
     (every one is worth more than the gap), and adding regular dishes never does. */
  function seasonalNudge(r) {
    return r && r.seasonal && r.kind === 'mixed-progress'
      ? lbnT('ship.seasonal_add_one', 'Add 1 more seasonal dish for FREE delivery') : null;
  }

  function pillPreview(code, total, frozenShip, mixed) {
    if (code === 'east-msia') return { txt: lbnT('ship.core_pill_from', 'from {{ amount }}', { amount: fmt(EAST_FROM) }), free: false };
    if (code === 'west-msia') return total >= TDRY ? { txt: lbnT('ship.free_caps', 'FREE'), free: true } : { txt: fmt(RD), free: false };
    /* Every order containing frozen food previews its paid cold-chain tier. */
    if (frozenShip && code === 'kl-sel') return { txt: fmt(total >= TMIX_KL ? RMIX_KL : RF_KL), free: false };
    if (frozenShip && code === 'wm') return { txt: fmt(total >= TMIX_WM ? RMIX_WM : RF_WM), free: false };
    return { txt: '', free: false };
  }

  /* ---- Shared lane analytics (brief section 8) -------------------------------
     Both the collection bar and the cart footer call trackLane(); neither one
     decides what a mixed cart is or what a milestone is. Per-surface memory so
     the same event does not double-fire when one page re-renders. */
  var laneMemory = {};
  function beacon(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      data = data || {};
      data.event = event;
      window.dataLayer.push(data);
    } catch (e) { /* analytics must never break a shipping surface */ }
  }
  function lanePayload(surface, s) {
    return {
      surface: surface,
      region: s.state || null,
      lane: s.lane,
      cart_value: s.total,
      frozen_qty: s.paidFrozenQty,
      retort_qty: s.paidRetortQty,
      shipping_fee: s.kind === 'free' ? 0 : (s.rate != null ? s.rate : null),
      milestone_status: s.kind === 'mixed-floor' ? 'reached' : (s.kind === 'mixed-progress' ? 'below' : 'n/a')
    };
  }
  /* Only SETTLED money states are tracked. 'moq', 'pickstate' and 'empty' are
     unresolved - the shopper has not been shown a fee yet - so they neither
     emit nor overwrite the remembered lane. No customer identifiers and no
     line-item names are ever included (brief section 8). */
  function trackLane(surface, s) {
    if (!s || !s.lane) return;
    if (s.kind === 'empty' || s.kind === 'moq' || s.kind === 'pickstate') return;
    var prev = laneMemory[surface];
    /* A mixed cart to East Malaysia is settled but shows NO fee - it shows
       "not available". Counting that as a fee view would inflate the lane's
       denominator with impressions where no price was ever displayed. */
    var showsMixedFee = s.kind === 'mixed-progress' || s.kind === 'mixed-floor';
    if (showsMixedFee && (!prev || prev.lane !== 'mixed')) beacon('lbf_mixed_fee_view', lanePayload(surface, s));
    if (prev && prev.lane !== s.lane) {
      if (s.lane === 'mixed') beacon('lbf_pure_to_mixed_switch', lanePayload(surface, s));
      else if (prev.lane === 'mixed') beacon('lbf_mixed_to_pure_switch', lanePayload(surface, s));
    }
    if (s.kind === 'mixed-floor' && (!prev || prev.kind !== 'mixed-floor')) beacon('lbf_mixed_milestone_reached', lanePayload(surface, s));
    laneMemory[surface] = { lane: s.lane, kind: s.kind };
  }

  window.LBF_SHIPPING = {
    TKL: TKL, TWM: TWM, TDRY: TDRY, RD: RD, RF_KL: RF_KL, RF_KL_RED: RF_KL_RED, RF_WM: RF_WM, RF: RF_WM, TKL_RED: TKL_RED, EAST_FROM: EAST_FROM, MOQ: MOQ,
    TMIX_KL: TMIX_KL, RMIX_KL: RMIX_KL, TMIX_WM: TMIX_WM, RMIX_WM: RMIX_WM,
    TSEA_KL: TSEA_KL, TSEA_WM: TSEA_WM, SEA_FREE_QTY: SEA_FREE_QTY, seasonalFee: seasonalFee, seasonalNudge: seasonalNudge,
    FROZEN_TYPE: FROZEN_TYPE, RETORT_TYPE: RETORT_TYPE, FROZEN_TAGS: FROZEN_TAGS, SOLO_TAG: SOLO_TAG,
    LEGACY_REGION_KEY: LEGACY_REGION_KEY, REGULAR_REGION_KEY: REGULAR_REGION_KEY, FROZEN_REGION_KEY: FROZEN_REGION_KEY,
    fmt: fmt, getRegularRegion: getRegularRegion, getFrozenRegion: getFrozenRegion,
    setRegularRegion: setRegularRegion, setFrozenRegion: setFrozenRegion,
    activeRegion: activeRegion, compute: compute, classify: classify, splitQuote: splitQuote, voucherFromCart: voucherFromCart,
    trackLane: trackLane, lanePayload: lanePayload,
    pillPreview: pillPreview
  };
})();
